import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services, HowItWorks } from "@/components/landing/Services";
import { AiTools } from "@/components/landing/AiTools";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials, Faq } from "@/components/landing/Social";
import { QuoteForm } from "@/components/landing/QuoteForm";
import { Footer, WhatsAppButton } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <Header />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <AiTools />
        <Pricing />
        <Testimonials />
        <Faq />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
